export default __webpack_public_path__ + "static/search-bc56c04acff49b5c5324a0aa6d9cf70c.gif";